interface Props {
  title: string
  totalProducts: number
  hiddenProductsCount: number
  isOffline: boolean
  isPartiallyOffline: boolean
  freeze: boolean
  onClick: () => void
}

export const Category: React.FC<Props> = ({
  title,
  totalProducts,
  hiddenProductsCount,
  isOffline,
  isPartiallyOffline,
  freeze,
  onClick
}) => {
  const status = isOffline ? 'OFFLINE' : isPartiallyOffline ? 'PARTIALLY OFFLINE' : 'ONLINE'
  const statusClassName = isOffline
    ? 'bg-red-100 text-red-700'
    : isPartiallyOffline
      ? 'bg-amber-100 text-amber-700'
      : 'bg-green-100 text-green-700'

  return (
    <div className={`bg-white shadow rounded-lg mb-4 font-sans ${freeze ? 'opacity-50' : ''}`}>
      <div className="px-4 py-5 sm:p-6">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>
            <p className="mt-2 text-xs font-mono text-gray-500">
              {hiddenProductsCount}/{totalProducts} products offline
            </p>
          </div>
          <span className={`rounded-full px-3 py-1 text-xs font-semibold ${statusClassName}`}>{status}</span>
        </div>

        <div className="mt-5 sm:flex sm:items-center sm:justify-between">
          <div className="max-w-xl text-[12px] font-mono text-gray-500">
            <p>
              {totalProducts} product{totalProducts > 1 ? 's' : ''} in this category
            </p>
          </div>

          <div className="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
            <button
              disabled={freeze || totalProducts === 0}
              onClick={onClick}
              type="button"
              className={`w-full justify-center inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white ${
                isOffline ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'
              } focus:outline-none sm:text-sm disabled:cursor-not-allowed disabled:opacity-50`}
            >
              {isOffline ? 'SHOW CATEGORY' : 'MASK CATEGORY'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
